import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import appTabFooter from "../components/appTabFooter.vue";
import mangeHeader from "../components/mangeHeader.vue";
// import gameList from "../views/gameList.vue";
// import myData from "../views/myData.vue";
// import userSetting from "../views/userSetting.vue";
// import gameOpenInfo from "../views/gameOpenInfo.vue";
// import adWeb from "../views/adWeb.vue";
// import courseInfo from "../views/courseInfo.vue"
// import noticePage from "../views/noticePage.vue"
// import messagePage from "../views/messagePage.vue"

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    components: {
      default: Home,
      footer: appTabFooter,
    },
    meta: {
      keepAlive: true, // true 表示需要使用缓存
    },
  },
  {
    path: "/gameOpenInfo",
    name: "gameOpenInfo",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    
    // components: {
    //   default: gameOpenInfo
    // },
    components: {// test
      default: () =>
        import(/* webpackChunkName: "about" */ "../views/gameOpenInfo.vue"),
    },
  },
  {
    path: "/gameEditInfo",
    name: "gameEditInfo",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    components: {
      default: () =>
        import(/* webpackChunkName: "about" */ "../views/gameEditInfo.vue"),
    },
  },
  {
    path: "/gameManagement/:id",
    name: "gameManagement",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    components: {
      header: mangeHeader,
      default: () =>
        import(/* webpackChunkName: "about" */ "../views/gameManagement.vue"),
    },
  },
  {
    path: "/gameManagement/:id/gameDonate",
    name: "gameDonate",
    components: {
      default: () =>
        import(/* webpackChunkName: "about" */ "../views/gameDonate.vue"),
      },
  },
  {
    path: "/gameManagement/:id/gameRestaurant",
    name: "gameRestaurant",
    components: {
      default: () =>
        import(/* webpackChunkName: "about" */ "../views/gameRestaurant.vue"),
      },
  },
  {
    path: "/gameRecordCard/:id/",
    name: "gameRecordCard",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    components: {
      default: () =>
        import(/* webpackChunkName: "about" */ "../views/gameRecordCard.vue"),
    },
  },
  {
    path: '/myGame/:courseName',
    name: 'myGameByCourse',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    components: {
      default: () => import(/* webpackChunkName: "about" */ '../views/myGameByCourse.vue'),
    }
  },
  {
    path: '/gameList',
    name: 'gameList',
    meta: {
      keepAlive: true, // true 表示需要使用缓存
    },
    components: {
      // default: gameList,
      default: () => import(/* webpackChunkName: "about" */ '../views/gameList.vue'),
      footer: appTabFooter,
    },
  },
  {
    path: "/myData",
    name: "myData",
    // meta: {
    //   keepAlive: true  // true 表示需要使用缓存
    // },
    components: {
      // default: myData,
      default: () => import(/* webpackChunkName: "about" */ '../views/myData.vue'),
      footer: appTabFooter,
    },
  },
  {
    path: "/noticePage",
    name: "noticePage",
    components: {
      // default: noticePage,
      default: () => import(/* webpackChunkName: "about" */ '../views/noticePage.vue'),
      footer: appTabFooter
    },
  },
  {
    path: "/userSetting",
    name: "userSetting",
    components: {
      // default: userSetting,
      default: () => import(/* webpackChunkName: "about" */ '../views/userSetting.vue'),
      footer: appTabFooter,
    },
  },
  {
    path: "/adWeb/:name",
    name: "adWeb",
    components: {
      default: () => import(/* webpackChunkName: "about" */ '../views/adWeb.vue'),
      // default: adWeb
    },
  },
  {
    path: "/courseInfo",
    name: "courseInfo",
    components: {
      default: () => import(/* webpackChunkName: "about" */ '../views/courseInfo.vue'),
      // default: courseInfo
    },
  },
  {
    path: "/messagePage",
    name: "messagePage",
    components: {
      default: () => import(/* webpackChunkName: "about" */ '../views/messagePage.vue'),
      // default: messagePage,
    },
    props: true,
    
  },
  

];

const router = new VueRouter({
  
  mode: 'history',
  // base:"/app/",
  routes,
  
});
export default router;
